import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('UserLevel', UserLevel);

  UserLevel.$inject = [];

  /* @ngInject */
  function UserLevel() {
    UserLevel.prototype = {
      build: build,
      buildEmpty: buildEmpty
    };

    function UserLevel(userLevelData) {
      if (!userLevelData) {
        this.buildEmpty();
      } else {
        this.build(userLevelData);
      }
    }

    return UserLevel;

    /////////////////////

    function buildEmpty() {
      this.roles = [];
      this.level = null;
    }

    function build(userLevelData) {
      this.roles = userLevelData.roles;
      this.level = userLevelData.level;
    }
  }
})();
